module.exports = __webpack_public_path__ + "static/media/PT.ada259b5.svg";